export const PLUGIN_NAME = 'rollup-plugin-keywords';
